import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'

export class LvcSwitch extends MinzeElement {
  reactive: Reactive = [['active', false, true]]

  attrs: Attrs = ['name', 'id', 'label', ['default-active', '']]

  static observedAttributes = ['name', 'id', 'default-active']

  onAttributeChange = (name: string, oldValue: string, newValue: string) => {
    if (name === 'default-active' && oldValue !== newValue) {
      this.active = newValue ?? ''
    }
  }

  toggleActive = () => (this.active = !this.active)

  html = () => `
      <div class="indicator"></div>
    `

  css = () => `
      :host {
        width: 48px;
        height: 25px;
        display: flex;
        background: transparent;
        background: ${this.active ? '#1E007D' : 'transparent'};
        border: 1px solid #1E007D;
        border-radius: 9999px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        padding: 2px;
      }

      .indicator {
        width: 19px;
        height: 19px;
        background: ${this.active ? '#fff' : '#1E007D'};
        border-radius: 9999px;
        position: relative;
        transform: translateX(${this.active ? 'calc(100% + 4px)' : '0'});
        transition: all 0.2s ease-in-out;
      }
    `

  eventListeners: EventListeners = [[this, 'click', this.toggleActive]]
}
